import type { ICustomCategories } from "app/services/category/userCustomCategoryService";
import { getHttpHeaders } from "app/services/fetchService/httpHeaders";
import type { IUserKeywordGroup } from "app/services/keyword-groups/keywordGroups.types";

type ISharedAssets = {
    customIndustries?: ICustomCategories;
    keywordGroups?: IUserKeywordGroup[];
};

let sharedAssets: ISharedAssets = {};
let currentSetAssetsFetch: Promise<void> | null = null;
let sharedAssetsFetched = false;

const fetchSharedAssets = () => {
    if (currentSetAssetsFetch) return currentSetAssetsFetch;

    currentSetAssetsFetch = fetch("/api/userdata/reachable", {
        credentials: "include",
        headers: getHttpHeaders(),
    }).then((data) =>
        data.json().then((data) => {
            sharedAssets = data;
            currentSetAssetsFetch = null;
            sharedAssetsFetched = true;
        }),
    );

    return currentSetAssetsFetch;
};

export const getSharedCustomCategories = (forceFetch?: boolean) => {
    return new Promise(async (resolve) => {
        if (forceFetch || !sharedAssetsFetched) {
            await fetchSharedAssets();
        }
        resolve(sharedAssets.customIndustries);
    });
};

const getSharedKeywordsGroups = async (forceFetch?: boolean) => {
    return new Promise(async (resolve) => {
        if (forceFetch || !sharedAssetsFetched) {
            await fetchSharedAssets();
        }
        resolve(sharedAssets.keywordGroups);
    });
};
